// extracted by mini-css-extract-plugin
export default {"page":"AccessDenied_page__JLdTJ"};